var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9627 6.65389H11.2515C10.7518 6.65389 10.3467 6.24857 10.3467 5.74885V2.03791C10.3467 1.01805 9.52006 0.191406 8.5002 0.191406C7.48053 0.191406 6.65388 1.01805 6.65388 2.03791V5.74885C6.65388 6.24857 6.24857 6.65389 5.74885 6.65389H2.03791C1.01805 6.65389 0.191406 7.48053 0.191406 8.5002C0.191406 9.51987 1.01805 10.3465 2.03791 10.3465H5.74885C6.24857 10.3465 6.65388 10.7518 6.65388 11.2516V14.9625C6.65388 15.9823 7.48053 16.809 8.5002 16.809C9.52006 16.809 10.3467 15.9823 10.3467 14.9625V11.2516C10.3467 10.7518 10.7518 10.3465 11.2515 10.3465H14.9627C15.9823 10.3465 16.809 9.51987 16.809 8.5002C16.809 7.48053 15.9823 6.65389 14.9627 6.65389Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigAdd);
export default __webpack_public_path__ + "static/media/big-add.c1e2b3c8eef698f628ab07fce744c79b.svg";
export { ForwardRef as ReactComponent };